module.exports = __webpack_public_path__ + "static/media/D.2ed6d675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/D.jpg
// module id = 72
// module chunks = 0